import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="newspaper-1, guide, info, faq, book"><path d="M11.25 5.37711L4.13085 3.78973C3.03762 3.54597 2 4.37771 2 5.49779V17.8862C2 18.7059 2.56905 19.4158 3.36915 19.5942L11.25 21.3514V5.37711Z" fill="currentColor"/><path d="M12.75 21.3514L20.6308 19.5942C21.431 19.4158 22 18.7059 22 17.8862V5.49778C22 4.37771 20.9624 3.54597 19.8691 3.78973L12.75 5.37711V21.3514Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNewspaper1;
